/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NoticeDto } from '../../models/notice-dto';
import { UpdateNoticeDto } from '../../models/update-notice-dto';

export interface NoticeControllerUpdateV1$Params {
  id: string;
      body: UpdateNoticeDto
}

export function noticeControllerUpdateV1(http: HttpClient, rootUrl: string, params: NoticeControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NoticeDto>> {
  const rb = new RequestBuilder(rootUrl, noticeControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NoticeDto>;
    })
  );
}

noticeControllerUpdateV1.PATH = '/api/v1/notice/{id}';
